export default "__VITE_ASSET__DuzMzPz3__"